module.exports = __webpack_public_path__ + "media/thankyou_message_2.49105d74.mp3";